export default {
  title: 'Access control',
  recoveryButton: 'Recover password',
  newLink: 'Sign up',
  oldVersion: `Access to the classic version of efactura's web module`,
  help: 'If you need help access our ',
  usermanual: `user's manual`,
  subtitle1: 'If you are a provider, through our service you can, among other operations:',
  text1: 'Issue invoices and send them to your clients',
  text2: 'To know the status of the processing of your invoices by your customers',
  subtitle2: 'And as a customer, through our service you can, among other operations:',
  text3: 'Know the invoices that your suppliers have issued',
  text4: 'Accept or reject received invoices',
  text5: 'Electronically store invoices issued during the legally established period.',
  text6: 'Retrieve a duplicate of any invoice stored as valid by the Spanish Tax Agency',
  button: 'Login',
  access: 'Access the platform',
  howItWorks: 'How eFactura works',
  news: 'News and updates',
  user: 'User:',
  password: 'Password:',
  nif: 'NIF/CIF/NIE/Other:',
  removeOldVersion: 'The classic version will cease to be operational on 15/11/2022',
  validate: {
    user: 'user',
    password: 'password',
    nif: 'nif'
  },
  contract: {
    text: 'For more infomation, please contact us at',
    link: 'soporte.sistemaefactura@unifiedpost.com'
  },
  recovery: {
    title: 'Recover access password',
    user: 'User',
    nif: 'NIF/CIF/NIE/Other:',
    email: 'Email',
    button: 'Send password',
    ok: `Password sent to the user's email`
  },
  temporalToken: {
    activeOk: 'Account has been activated correctly'
  },
  resetpasswd: {
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    restaurar: 'Reset',
    caracteresMinimos: '6 characters minimum',
    ok: 'Password changed successfully'
  },
  registry: {
    title: 'Register a new company',
    companyData: 'Company data',
    nif: 'NIF',
    reason: 'Business name',
    address: 'Address',
    addressPlaceholder: 'C\\',
    zipCodePlaceholder: 'Postal Code',
    townPlaceholder: 'City',
    cityPlaceholder: 'Province',
    countryPlaceholder: 'Country',
    email: 'Email',
    phone: 'Phone number',
    accessData: 'Access data',
    user: 'User',
    pass: 'Password',
    rePass: 'Repeat password',
    repeatEmail: 'Repeat email',
    buttonRegistry: 'Sign up',
    buttonCancelRegistry: 'Cancel',
    acceptConditions: 'I agree to the terms and conditions',
    captcha: 'captcha',
    validate: 'Validate',
    companyAlrealdyExists: 'The company is already registered, if you have trouble accessing, contact our support at ',
    informaError: 'Unable to retrieve data from the indicated CIF / NIF, contact our support at ',
    seeTerms: 'see terms and conditions',
    modal: {
      title: 'Sign up complete',
      text: 'Enjoy our free service, our sales department will contact you shortly.',
      button: 'Accept'
    },
    errors: {
      5000: 'An unexpected error has occurred.',
      5001: 'To register in the system, you must enter a corporate email account.',
      5002: 'There was an error sending the account activation email, please contact our support team ',
      5003: 'There was an error creating the new user.',
      5004: 'An error occurred while searching for the user.',
      5005: 'There was an error registering the company in the main system.',
      5006: 'There was an error updating the user.',
      5007: 'Unable to register the indicated user, try entering another.'
    }
  },
  sesion: {
    error: 'Expired session',
    bankiaError: 'Connection error. Error code: ',
    longError: 'Your session has expired, you are redirected to the login page',
    user_pass_invalid: 'User or password are wrong',
    user_pass_invalid_jcyl: 'Incorrect username or password. If you do not remember your password, please send an email to <a href="mailto:igacyl.factura@jcyl.es">igacyl.factura@jcyl.es</a>',
    error_cas: {
      401: 'A system access error has occurred. In case the error persists, please contact the Customer Service.',
      4011: 'Unauthorized access. The user must register on the Electronic Invoicing Platform of the Government of La Rioja. <a href="https://web.larioja.org/portal-facturacion-e" target="_blank" style="color:#695596 !important;">https://web.larioja.org/portal-facturacion-e</a>'
    },
    inactive_user: 'User is disabled temporarily, please contact us by mail adress ',
    inactive_user_jcyl: 'User is disabled temporarily, please contact us by mail adress ',
    blocked_user: 'User is blocked, to unblock it please click on the following link: <a href="/recovery" style="color:#695596 !important;">restore the password</a>.',
    blocked_user_jcyl: 'User is blocked, please contact us by mail adress ',
    service_not_avaible: 'Service not avaible',
    service_not_avaible_jcyl: 'Service not avaible',
    expire: {
      title: 'Your session is due to expire',
      description: 'Your session is expiring in {0} min'
    }
  },
  eurobits: {
    title1: 'Send your invoices as electronic document',
    title2: 'Receive your invoices as electronic document',
    title3: 'Be notified when your invoice status changes',
    title4: 'Platform connection integration system',
    text1: 'Create your invoices online, import them, or directly incorporate them from your own ERP.',
    text2: 'Receive invoices from your provider in any format and manage them online or from your own ERP.',
    text3: 'Notification system that will send your an email when your invoice change status.',
    text4: 'Our platform is connected to other systems like (FACe, BiscayTIK, AOC, etc.).'
  }
}
